export const SENTRY_IGNORE_ERRORS: Array<string | RegExp> = [
  'ResizeObserver loop limit exceeded', // We can safely ignore this error: see https://github.com/WICG/resize-observer/issues/38 for details
  'ResizeObserver loop completed with undelivered notifications.', // A variant of the above error, see https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver
  'Non-Error promise rejection captured', // https://github.com/getsentry/sentry-javascript/issues/3440
  'Object captured as exception with keys: code, message',
  /Object captured as promise rejection with keys/,
  'Object captured as exception with keys: error, headers, message, name, ok',
]
